// Fire-and-forget provenance logger. Records where each article image came from
// (library_media | library_pisco | quick_add) so we can measure adoption of the
// new Media Library. Gated by REACT_APP_IMG_SOURCE_LOG; NEVER blocks or throws
// into the editor. POSTs to the absinthe route
//   POST /article/:domainId/image-source/:articleId
// which no-ops safely if the log table hasn't been created yet.

export function logArticleImageSource(evt) {
  try {
    if (process.env.REACT_APP_IMG_SOURCE_LOG !== "true") return;
    var e = evt || {};
    if (!e.articleId || !e.domainId || !e.source) return;
    var base = process.env.REACT_APP_API_SERVER || "";
    var token = localStorage.getItem("accessToken");
    fetch(base + "/article/" + e.domainId + "/image-source/" + e.articleId, {
      method: "POST",
      keepalive: true,
      headers: {
        "Content-Type": "application/json",
        authorization: token
      },
      body: JSON.stringify({
        source: e.source,
        placement: e.placement || "body",
        assetUrl: e.assetUrl || null,
        publicId: e.publicId || null
      })
    }).catch(function () {
      /* telemetry must never break authoring */
    });
  } catch (err) {
    /* swallow */
  }
}

// Alias so callers can import either name.
export const logImageSource = logArticleImageSource;
